/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Relationship_ManagerInputs */



/**
* | output |
* | --- |
* | "Manager" |
*
* @param {Team_Relationship_ManagerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_relationship_manager = /** @type {((inputs?: Team_Relationship_ManagerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Relationship_ManagerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Leidinggevende")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Responsable")
	return /** @type {LocalizedString} */ ("Manager")
});